import { useQuery } from "@apollo/client";
import {
  GET_ACTIONS_SUMMARY,
  GET_ACTIONS_BILLING,
  GET_ACTIONS_RUNS,
} from "../graphql/queries/github";

interface UseActionsStatsOptions {
  owner: string;
  repo: string;
  bucket?: "day" | "week" | "month";
  since?: Date;
  until?: Date;
}

export function useActionsStats({
  owner,
  repo,
  bucket = "week",
  since,
  until,
}: UseActionsStatsOptions) {
  // Get summary data
  const {
    data: summaryData,
    loading: summaryLoading,
    error: summaryError,
    refetch: refetchSummary,
  } = useQuery(GET_ACTIONS_SUMMARY, {
    variables: {
      owner,
      repo,
      bucket,
      since,
      until,
    },
    fetchPolicy: "cache-and-network",
  });

  // Get billing data
  const {
    data: billingData,
    loading: billingLoading,
    error: billingError,
    refetch: refetchBilling,
  } = useQuery(GET_ACTIONS_BILLING, {
    variables: {
      scope: `user:${owner}`,
    },
    fetchPolicy: "cache-and-network",
  });

  // Get recent runs
  const {
    data: runsData,
    loading: runsLoading,
    error: runsError,
    refetch: refetchRuns,
  } = useQuery(GET_ACTIONS_RUNS, {
    variables: {
      owner,
      repo,
      since,
      until,
    },
    fetchPolicy: "cache-and-network",
  });

  const loading = summaryLoading || billingLoading || runsLoading;
  const error = summaryError || billingError || runsError;

  const refreshAll = async () => {
    await Promise.all([refetchSummary(), refetchBilling(), refetchRuns()]);
  };

  return {
    summary: summaryData?.actionsSummary || [],
    billing: billingData?.actionsBilling || null,
    runs: runsData?.actionsRuns || [],
    loading,
    error,
    refreshAll,
  };
}
